<template>
  <div>
    <v-row>
      <v-col>
        <v-toolbar flat color="transparent">
          <v-toolbar-title>
            Fakturering
          </v-toolbar-title>

          <v-spacer />

          <v-btn :loading="creating" @click="createInvoice">
            Opret fakturakladde
            <v-icon right>mdi-send-outline</v-icon>
          </v-btn>
        </v-toolbar>
      </v-col>
    </v-row>
    
    <v-row>
      <v-col>
        <v-card>
          <v-card-title>
            Fakturakladde
          </v-card-title>
          <v-card-text>
            <v-form>
              <v-row>
                <v-col>
                  <v-text-field v-model="invoice.title" label="Titel" outlined></v-text-field>
                </v-col>
                <v-col>
                  <v-text-field
                    v-model="invoice.dateTime"
                    type="date"
                    label="Fakturadato"
                    outlined
                  />
                </v-col>
              </v-row>
              <v-text-field v-model="invoice.subtitle" label="Undertitel" outlined></v-text-field>
              <v-textarea v-model="invoice.description" label="Beskrivelse" outlined></v-textarea>
            </v-form>
          </v-card-text>

          <v-card-text>
            <h3>Forhåndsvisning</h3>
          </v-card-text>

          <v-simple-table>
            <thead>
              <tr>
                <th>Varenummer</th>
                <th>Navn</th>
                <th v-if="errorInvoice">Fejl</th>
                <th class="text-right">Antal</th>
                <th class="text-right">Kostpris (stk.)</th>
                <th class="text-right">Stk. pris</th>
                <th class="text-right">Pris</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(line, index) of invoice.lines" :key="line.partNumber">
                <td>
                  <ClipboardCopy :route="`/parts/${line.partId}/edit`">
                    {{ line.partNumber }}
                  </ClipboardCopy>
                </td>
                <td>{{ line.partName }}</td>
                <td v-if="errorInvoice">{{ errorInvoice?.lines[index]?.errors?.at(0) }}</td>
                <td class="text-right">{{ line.quantity }}</td>
                <td class="text-right">{{ line.costPrice | formatNumberFixed2 }}</td>
                <td class="text-right">{{ line.price | formatNumberFixed2 }}</td>
                <td class="text-right">{{ line.price * line.quantity | formatNumberFixed2 }}</td>
              </tr>
            </tbody>
            <tfoot style="outline: thin solid">
              <tr>
                <td colspan="5" class="text-right">Subtotal</td>
                <td class="text-right">{{ subtotal | formatNumberFixed2 }}</td>
              </tr>
              <tr>
                <td colspan="5" class="text-right">25,00% moms</td>
                <td class="text-right">{{ subtotal * 0.25 | formatNumberFixed2 }}</td>
              </tr>
              <tr class="font-weight-bold">
                <td colspan="5" class="text-right">Total DKK</td>
                <td class="text-right">{{ subtotal * 1.25 | formatNumberFixed2 }}</td>
              </tr>
            </tfoot>
          </v-simple-table>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import ClipboardCopy from '@/components/ClipboardCopy.vue';

function buildLine(part) {  
  const { title, quantity, costPrice, price, part_Id: partId, part_PartNumber: partNumber, sortOrder } = part;

  return {
    partId,
    partNumber,
    quantity,
    costPrice,
    price,
    partName: title,
    unit: 'stk',
    categoryGroupSortOrder: sortOrder
  }
}

export default {
  name: 'SpecificationInvoicing',
  components: { ClipboardCopy },
  data() {
    return {
      loading: false,
      creating: false,
      invoice: {
        dateTime: this.moment().format('YYYY-MM-DD'),
        title: `${this.spec.relationTitle} ${this.spec.title}`,
        subtitle: null,
        description: '',
        lines: []
      },
      errorInvoice: null
    }
  },
  computed: {
    subtotal() {
      return this.invoice.lines.reduce((prev, current) => prev + (current.price * current.quantity), 0)
    }
  },
  props: ['spec'],
  methods: {
    async createInvoice() {
      this.creating = true;

      try {
        const result = await this.$store.dispatch('createInvoice', this.invoice);
      } catch(error) {
        console.error(error);
        if (typeof error === 'object' && Array.isArray(error.lines)) {
          this.errorInvoice = error;
        }
      } finally {
        this.creating = false;
      }
    },
    setNow() {
      this.invoice.dateTime = this.moment().format('YYYY-MM-DD')
    },
  },
  mounted() {
    this.spec.groups.forEach(group => {
      group.sections.forEach(section => {
        section.parts.forEach(part => {
          const index = this.invoice.lines.findIndex(line => line.partNumber === part.part_PartNumber);

          if (index !== -1) {
            this.invoice.lines.at(index).quantity += part.quantity;
          } else {
            const line = buildLine(part);
            this.invoice.lines.push(line);
          }
        })
      })
    })
  }
}
</script>
